<!-- KYMW0001 マーク選択 -->
<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">マーク選択</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div>
          <!-- タイトル -->
          <h2>{{model.windowTitle}}</h2>
          <!-- マーク 表示エリア -->
          <!-- FlexGrid -->
          <wj-flex-grid id="dtg_MarkCodeList" #dtg_MarkCodeList
            [itemsSource]="model.markCodeList"  resizableColumns="false" sortableColumns="false" [allowDragging]="'None'"
            [isReadOnly]="true" [allowSorting]="false"
            [headersVisibility]="'Column'" [selectionMode]="'Row'" [tabindex]="0">
            <wj-flex-grid-column [minWidth]="5" [header]="' '" [width]="45" [binding]="'check'" [align]="'center'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <input type="checkbox" class="selected" [(ngModel)]="cell.item.check" [tabindex]="-1"/>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'マークコード'" [width]="110" [binding]="'markCode'" [align]="'left'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'マーク内容'" [width]="365" [binding]="'markName'" [align]="'left'">
            </wj-flex-grid-column>
          </wj-flex-grid>
        </div>
      </div>
    </td>
  </tr>

  <!-- フッター -->
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <!-- button 選択 -->
          <button #btn_Choose class="btn-primary" (click)="Choose()" [tabindex]="0" forcedEnabledMode="true">選択</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>

</table>